<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Report/AgentAssets'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เขตการขาย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAaDepartment'"
                    :name="'reAaDepartment'"
                    :select2-options="reAaDepartmentOptions"
                    multiple
                    v-model="reAaDepartment"
                  ></select2> -->
                  <treeselect
                    v-model="reAaDepartment"
                    :multiple="true"
                    :options="reAaDepartmentOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>จังหวัด:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAaProvince'"
                    :name="'reAaProvince'"
                    :select2-options="reAaProvinceOptions"
                    multiple
                    v-model="reAaProvince"
                  ></select2> -->
                  <treeselect
                    v-model="reAaProvince"
                    :multiple="true"
                    :options="reAaProvinceOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAaAgentCode'"
                    :name="'reAaAgentCode'"
                    :select2-options="reAaAgentCodeOptions"
                    multiple
                    v-model="reAaAgentCode"
                  ></select2> -->
                  <treeselect
                    v-model="reAaAgentCode"
                    :multiple="true"
                    :options="reAaAgentCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAaStatus'"
                    :name="'reAaStatus'"
                    :select2-options="reAaStatusOptions"
                    v-model="reAaStatus"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAaProductTypeId'"
                    :name="'reAaProductTypeId'"
                    :select2-options="reAaProductTypeIdOptions"
                    multiple
                    v-model="reAaProductTypeId"
                  ></select2> -->
                  <treeselect
                    v-model="reAaProductTypeId"
                    :multiple="true"
                    :options="reAaProductTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAaProductBrand'"
                    :name="'reAaProductBrand'"
                    :select2-options="reAaProductBrandOptions"
                    multiple
                    v-model="reAaProductBrand"
                  ></select2> -->
                  <treeselect
                    v-model="reAaProductBrand"
                    :multiple="true"
                    :options="reAaProductBrandOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAaAssetCode'"
                    :name="'reAaAssetCode'"
                    :select2-options="reAaAssetCodeOptions"
                    multiple
                    v-model="reAaAssetCode"
                  ></select2> -->
                  <treeselect
                    v-model="reAaAssetCode"
                    :multiple="true"
                    :options="reAaAssetCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>

              <div class="col-xl-6 text-right">
                <button class="btn btn-outline-primary" @click="ExportAgentAssets($event)" type="submit">
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="stockByAgentTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="13">
                      ข้อมูล ณ วันที่ {{ reAaDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">เขตการขาย</th>
                    <th class="all text-center">จังหวัด</th>
                    <th class="all text-center">รหัสตัวแทนจำหน่าย</th>
                    <th class="all text-center">ตัวแทนจำหน่าย</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">รหัสสินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th class="all text-center">แบรนด์สินค้า</th>
                    <th class="all text-center">สถานะ</th>
                    <th class="all text-center">จำนวน (ตัวแทน)</th>
                    <th class="all text-center">จำนวน (ร้านค้า)</th>
                    <th class="all text-center">หน่วยนับ</th>
                  </tr>
                </thead>
                <!-- <tfoot v-show="isShowFooter">
                    <tr>
                        <th class="text-right" colspan="6">จำนวนรวม</th>
                        <th class="text-center">{{TotalAmount}}</th> 
                        <th class="text-center" colspan="5"></th> 
                    </tr>
                </tfoot> -->
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reAaIsInitial: true,
      reAaDateReq: null,
      reAaDepartment: [],
      reAaProvince: [],
      reAaAgentCode: [],
      reAaStatus: null,
      reAaProductTypeId: [],
      reAaProductBrand: [],
      reAaAssetCode: [],

      reAaStatusOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกสถานะ",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reAaProductTypeIdOptions: [],
      // reAaProductTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAaProductBrandOptions: [],
      // reAaProductBrandOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAaAssetCodeOptions: [],
      // reAaAssetCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAaDepartmentOptions: [],
      // reAaDepartmentOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเขตการขาย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchDepartment",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAaProvinceOptions: [],
      // reAaProvinceOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกจังหวัด",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2AgentProvince",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAaAgentCodeOptions: [],
      // reAaAgentCodeOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Options",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลตัวแทนจำหน่าย";
      //     },
      //   },
      // },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.reAaDepartment = [];
      self.reAaProvince = [];
      self.reAaAgentCode = [];
      self.reAaStatus = null;
      self.reAaProductTypeId = [];
      self.reAaProductBrand = [];
      self.reAaAssetCode = [];

      $("#reAaDepartment")
        .val("")
        .trigger("change");

      $("#reAaProvince")
        .val("")
        .trigger("change");

      $("#reAaAgentCode")
        .val("")
        .trigger("change");

      $("#reAaStatus")
        .val("")
        .trigger("change");

      $("#reAaProductTypeId")
        .val("")
        .trigger("change");

      $("#reAaProductBrand")
        .val("")
        .trigger("change");

      $("#reAaAssetCode")
        .val("")
        .trigger("change");
    },
    formSubmit: function(e) {
      let self = this;

      e.preventDefault();
      var table = $("#stockByAgentTable").DataTable();
      table.draw();
    },
    LoadreAaProductTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAaProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAaProductBrandOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAaProductBrandOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAaAssetCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAaAssetCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAaDepartmentOptions: function(e) {
      var self = this;
      axios
        .get("/Api/MasterSalesArea/FindOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAaDepartmentOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAaProvinceOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/Select2AgentProvince", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAaProvinceOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAaAgentCodeOptions: function(e) {
      var self = this;
      axios
        // .post("/Api/Agents/Options", {
        //   page: 1,
        //   province_id: [],
        //   department: [],
        //   AgentCodes: [],
        // })
        .post(
          "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
          {
            province_id: [],
            department: [],
            AgentCodes: [],
            page: 1,
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAaAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ExportAgentAssets: function (e) {
      e.preventDefault();
      let self = this;

      // if (
      //   !self.reMmBarcode &&
      //   !self.reMmDepartmentMaterialCode &&
      //   !self.reMmNFCCode &&
      //   !self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกเงื่อนไขรายงาน", "warning");
      //   return false;
      // }

      // if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
      //   return false;
      // } else if (
      //   self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
      //   return false;
      // }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportAgentAssets",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reAaIsInitial,
          SalesArea: self.reAaDepartment,
          Province: self.reAaProvince,
          AgentCode: self.reAaAgentCode,
          Status: self.reAaStatus,
          ProductTypeId: self.reAaProductTypeId,
          AssetCode: self.reAaAssetCode,
          BrandId: self.reAaProductBrand,
        },
      })
        .then(function (response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function () {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;

    self.LoadreAaProductTypeIdOptions();
    self.LoadreAaProductBrandOptions();
    self.LoadreAaAssetCodeOptions();
    self.LoadreAaDepartmentOptions();
    self.LoadreAaProvinceOptions();
    self.LoadreAaAgentCodeOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#stockByAgentTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/AgentAssets",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              IsInitial: self.reAaIsInitial,
              SalesArea: self.reAaDepartment,
              Province: self.reAaProvince,
              AgentCode: self.reAaAgentCode,
              Status: self.reAaStatus,
              ProductTypeId: self.reAaProductTypeId,
              AssetCode: self.reAaAssetCode,
              BrandId: self.reAaProductBrand,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[1, "desc"]],
        columns: [
          {
            data: "department",
            className: "text-center",
            render: function(data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          { data: "department", className: "text-center" },
          { data: "province", className: "text-center" },
          { data: "agentCode", className: "text-center" },
          { data: "agentName", className: "text-center" },
          { data: "productTypeName", className: "text-center" },
          { data: "assetCode", className: "text-center" },
          { data: "assetName", className: "text-center" },
          { data: "brandName", className: "text-center" },
          { data: "statusName", className: "text-center" },
          {
            data: "agentAssetAmount",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data != null || data != "" || data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "shopAssetAmount",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data != null || data != "" || data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          { data: "salesUnit", className: "text-center" },
        ],
        drawCallback: function(settings) {
          self.reAaIsInitial = false;
          self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

          // var allPage = table.DataTable().page.info().pages;
          // var currentPage = table.DataTable().page.info().page +1;

          // self.isShowFooter = false;
          // self.TotalAmount = 0;

          // if(allPage == currentPage){
          //   self.isShowFooter = true;
          //   self.TotalAmount = settings.json.data[0].totalAmount;
          // }
        },
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.form, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.form);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/AgentAssets.vue